import React, { useEffect } from "react";

import "./style.scss";

export const PostMessageSuccessPage = () => {

  useEffect(() => {
    window.parent.postMessage("PAYMENT_SUCCESS");
  }, []);

  return (
    <div className="post-message-success-container">
      <div>
        Payment Method added successfully
      </div>
    </div>
  )
}